import React from "react";
import Layout from "../../Layout";
import HeaderUser from "../HeaderUser";
import FormUserRegistration from "./FormUserRegistration";

const RegistrationUser = () => (
  <Layout>
    <HeaderUser />
    <section className="layout-container">
      <div className="container">
        <div className="descript-container container-2">
          <div className="form-title g-clr">Registration</div>
          Use this form to pre-register individuals and ensure they receive an
          email notification once their account is created. They will be able to
          log in with a temporary password and follow a few simple steps to
          finalize their registration and start using the system immediately.
          Their contact information will be instantly available in the User
          Directory.
        </div>
        <FormUserRegistration />
      </div>
    </section>
  </Layout>
);

export default RegistrationUser;
